import React from "react";
import "../css/inscripciones.css";
const precios = [
  { categoria: "Miembros de ASAEE", precio: "USD 200" },
  { categoria: "Profesionales", precio: "USD 250" },
  { categoria: "Profesionales sin ponencia y estudiantes de posgrado", precio: "USD 150" },
  { categoria: "Estudiantes de grado", precio: "USD 100" }
];

const beneficios = [
  "🍸 Cóctel de bienvenida",
  "🍽 Cena oficial del Día 2 del evento"
];

export default function Inscripciones() {
  return (
    <section className="inscripciones">
      
      <h2><b>Costos </b>de inscripción</h2>
     <center>  <p>¡Próximamente inscripciones abiertas!</p></center>

      <div className="lista-precios">
        {precios.map((item, index) => (
          <div className="precio-card" key={index}>
            <span className="numero">{index + 1}</span>
            <div>
              <h3>{item.precio}</h3>
              <p>{item.categoria}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="beneficios">
        <h3>Beneficios para miembros de ASAEE y Profesionales</h3>
        <p>Los miembros tendrán acceso exclusivo a:</p>

        <ul>
          {beneficios.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </ul>
      </div>


    </section>
  );
}